// RecentActivity.tsx
import React from 'react';
import { Clock, ArrowUpRight } from 'lucide-react';
import { motion } from 'framer-motion';

const ACTIVITY = [
  { type: 'rfq', dot: 'bg-blue-500', title: 'New RFQ created', when: '2 hours ago' },
  { type: 'booking', dot: 'bg-emerald-500', title: 'Booking confirmed', when: '5 hours ago' },
  { type: 'rate', dot: 'bg-violet-500', title: 'Rate search completed', when: '1 day ago' },
  { type: 'delay', dot: 'bg-rose-500', title: 'Shipment delayed', when: '2 days ago' },
];

export function RecentActivity() {
  return (
    <motion.section 
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.2 }}
      className="rounded-2xl bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-700 shadow-sm overflow-hidden"
      data-testid="recent-activity"
    >
      <div className="px-5 py-4 border-b border-slate-100 dark:border-slate-800 flex items-center justify-between">
        <div className="text-[14px] font-semibold text-slate-900 dark:text-white">Recent Activity</div>
        <button className="text-[11.5px] text-emerald-600 dark:text-emerald-400 hover:underline transition-colors">
          View all
        </button>
      </div>
      <div className="p-5 relative">
        <span aria-hidden className="absolute left-[33px] top-7 bottom-7 w-px bg-slate-200 dark:bg-slate-700" />
        <ul className="space-y-4">
          {ACTIVITY.map((a, i) => (
            <motion.li
              key={i}
              initial={{ x: -20, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.3, delay: i * 0.1 }}
              className="relative flex items-start gap-3 group cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-800/50 rounded-lg transition-all duration-200 p-2 -m-2"
            >
              <span className={`relative z-10 w-3 h-3 rounded-full ${a.dot} ring-4 ring-white dark:ring-slate-900 mt-1.5 ml-3 shadow-sm`} />
              <div className="flex-1 flex items-start justify-between gap-2">
                <div>
                  <div className="text-[13px] font-medium text-slate-900 dark:text-white">{a.title}</div>
                  <div className="text-[11px] text-slate-500 dark:text-slate-400 inline-flex items-center gap-1 mt-0.5">
                    <Clock className="w-3 h-3" /> {a.when}
                  </div>
                </div>
                <button className="text-slate-400 dark:text-slate-500 hover:text-slate-700 dark:hover:text-slate-300 mt-1 transition-colors opacity-0 group-hover:opacity-100">
                  <ArrowUpRight className="w-4 h-4" />
                </button>
              </div>
            </motion.li>
          ))}
        </ul>
      </div>
    </motion.section>
  );
}

export default RecentActivity;